/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_user_menu_settings16 = /** @type {(inputs: {}) => string} */ () => {
	return `Settings`
};

const fr_user_menu_settings16 = /** @type {(inputs: {}) => string} */ () => {
	return `Paramètres`
};

const de_user_menu_settings16 = /** @type {(inputs: {}) => string} */ () => {
	return `Einstellungen`
};

const es_user_menu_settings16 = /** @type {(inputs: {}) => string} */ () => {
	return `Ajustes`
};

const it_user_menu_settings16 = /** @type {(inputs: {}) => string} */ () => {
	return `Impostazioni`
};

const ar_user_menu_settings16 = /** @type {(inputs: {}) => string} */ () => {
	return `إعدادات`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "fr" | "de" | "es" | "it" | "ar" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const user_menu_settings16 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.user_menu_settings16(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("user_menu_settings16", locale)
	if (locale === "en") return en_user_menu_settings16(inputs)
	if (locale === "fr") return fr_user_menu_settings16(inputs)
	if (locale === "de") return de_user_menu_settings16(inputs)
	if (locale === "es") return es_user_menu_settings16(inputs)
	if (locale === "it") return it_user_menu_settings16(inputs)
	return ar_user_menu_settings16(inputs)
};
export { user_menu_settings16 as "USER_MENU_SETTINGS" }